import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

/**
 * load translation
 */
export function HttpLoaderFactory(http: HttpClient): any {

  return new TranslateHttpLoader(http,

    './assets/i18n/',

    '.json');

}

@NgModule({ declarations: [],
    exports: [TranslateModule], imports: [CommonModule,
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            isolate: true,
            extend: false
        })], providers: [provideHttpClient(withInterceptorsFromDi())] })

export class NgxTranslateModule { }